import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { ProjectFolder } from "@/components/ProjectFolder";
import { Contact } from "@/components/Contact";
import { Testimonials } from "@/components/Testimonials";
import { Footer } from "@/components/Footer";
import { BookingWidget } from "@/components/BookingWidget";

export default function Home() {
  return (
    <div data-testid="home-page" className="font-body pb-[72px] md:pb-0">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <ProjectFolder />
        <Contact />
        <Testimonials />
      </main>
      <Footer />
      <BookingWidget />
    </div>
  );
}
